<template>
  <div class="container">
    <embed
      alt="eLuma Logo"
      src="/images/logo.svg"
    />
    <h2 v-html="'Sorry, we’re down for scheduled maintenance right now.'"/>
    <h3 v-text="'Please check back later.'"/>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue';

const Home = defineComponent({
  name: 'Home',

  setup() {
    const onRefresh = () => {
      window.location.reload();
    };

    const interval = () => {
      setInterval(() => onRefresh(), 60000);
    };

    const metaTitle = () => {
      document.title = 'eLuma - Maintenance';
    };

    onMounted(() => {
      metaTitle();
      interval();
    });

    return { onRefresh };
  },
});

export default Home;
</script>
